/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalAuthSubmission } from './PalAuthSubmission';
import {
    PalAuthSubmissionFromJSON,
    PalAuthSubmissionFromJSONTyped,
    PalAuthSubmissionToJSON,
    PalAuthSubmissionToJSONTyped,
} from './PalAuthSubmission';

/**
 * 
 * @export
 * @interface GetLatestPalSubmission200Response
 */
export interface GetLatestPalSubmission200Response {
    /**
     * 
     */
    data?: PalAuthSubmission;
}

/**
 * Check if a given object implements the GetLatestPalSubmission200Response interface.
 */
export function instanceOfGetLatestPalSubmission200Response(value: object): value is GetLatestPalSubmission200Response {
    return true;
}

export function GetLatestPalSubmission200ResponseFromJSON(json: any): GetLatestPalSubmission200Response {
    return GetLatestPalSubmission200ResponseFromJSONTyped(json, false);
}

export function GetLatestPalSubmission200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLatestPalSubmission200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PalAuthSubmissionFromJSON(json['data']),
    };
}

export function GetLatestPalSubmission200ResponseToJSON(json: any): GetLatestPalSubmission200Response {
    return GetLatestPalSubmission200ResponseToJSONTyped(json, false);
}

export function GetLatestPalSubmission200ResponseToJSONTyped(value?: GetLatestPalSubmission200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PalAuthSubmissionToJSON(value['data']),
    };
}

